/**
 * How long an action stays disabled after a successful fire.
 *
 * Each press puts a real signal in front of the monitoring centre, and a
 * double-tap produces two records that look like two events. Short enough not
 * to obstruct someone deliberately retrying.
 */
export const TEST_SIGNAL_COOLDOWN_MS = 10_000;

export function isOnCooldown(lastFiredAt: number | undefined, now: number): boolean {
  if (lastFiredAt === undefined) return false;
  return now - lastFiredAt < TEST_SIGNAL_COOLDOWN_MS;
}
